import {useSearchParams} from "react-router-dom";
import React from "react";

export const useUrlParams = (options) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const memoOptions = React.useMemo(() => options, [options]);

  const groupParamsByKey = (params, options) => [...params.entries()].reduce((acc, tuple) => {
    const [key, val] = tuple;
    const value = options?.[key]?.includes('number') ? Number(val) : val;
    if (acc.hasOwnProperty(key)) {
      if (Array.isArray(acc[key])) {
        acc[key] = [...acc[key], value];
      } else {
        acc[key] = [acc[key], value];
      }
    } else {
      const initialValue = options?.[key]?.includes('array') ? [value] : value;
      acc[key] = initialValue;
    }

    return acc;
  }, {});

  const urlParams = React.useMemo(() => groupParamsByKey(searchParams, memoOptions), [searchParams, memoOptions]);
  const updateUrlParams = React.useCallback((path) => setSearchParams({ ...urlParams, ...path }), [urlParams, setSearchParams]);
  return [urlParams, updateUrlParams, setSearchParams];
};